import { cn } from '@/lib/cn';

type LabelProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};

export const Label = ({ children, className, id }: LabelProps) => {
  return (
    <small
      id={id}
      className={cn('mb-3 text-xs tracking-[0.16em] text-(--uizz-antd-color-text-tertiary) uppercase', className)}
    >
      {children}
    </small>
  );
};
